<div class="incl-panel" [class.is-busy]="busy">
  @for (s of sections; track s.key) {
    @if (s.items.length > 0) {
      <div class="incl-card">
        <h6 class="incl-head">
          {{ s.label }}
          <span class="incl-count">{{ included(s).length }}</span>
        </h6>

        <div class="incl-chips">
          <!-- is-reorderable makes this wrapper (and the per-chip one below) a
               real layout box. Without manual editing it is display:contents,
               so the chips stay direct flex items of .incl-chips and the
               "Set aside" divider keeps flowing inline after them, exactly as
               before #1420. -->
          <div class="incl-chips-included" [class.is-reorderable]="manualEdit"
               cdkDropList cdkDropListOrientation="horizontal"
               [cdkDropListDisabled]="busy || disabled || !manualEdit" (cdkDropListDropped)="onDrop(s.key, $event)">
            @for (it of included(s); track it.item_id) {
              <div class="chip-drag" cdkDrag [cdkDragDisabled]="busy || disabled || !manualEdit">
                @if (manualEdit) {
                  <span class="chip-drag-handle" cdkDragHandle><nb-icon icon="menu-2-outline"></nb-icon></span>
                }
                <button
                  type="button"
                  class="chip-included"
                  [disabled]="busy || disabled"
                  [attr.aria-label]="('cv.tailor.inclusion.setAside' | translate) + ' · ' + it.name"
                  (click)="setAside.emit({ section: s.key, itemId: it.item_id })">
                  {{ it.name }}
                  <nb-icon class="chip-icon" icon="close-outline"></nb-icon>
                </button>
              </div>
            }
          </div>

          @if (included(s).length > 0 && setAsideList(s).length > 0) {
            <span class="set-aside-divider">{{ 'cv.tailor.inclusion.setAsideHead' | translate }} &middot; {{ setAsideList(s).length }}</span>
          }

          @for (it of setAsideList(s); track it.item_id) {
            <button
              type="button"
              class="chip-aside"
              [disabled]="busy || disabled"
              [attr.aria-label]="('cv.tailor.inclusion.restore' | translate) + ' · ' + it.name"
              [nbTooltip]="it.reason ?? ''"
              [nbTooltipDisabled]="!it.reason"
              (click)="restore.emit({ section: s.key, itemId: it.item_id })">
              <nb-icon class="chip-icon" icon="plus-outline"></nb-icon>
              {{ it.name }}
            </button>
          }
        </div>
      </div>
    }
  }
</div>
